export interface NavItem {
  label: string;
  href: string;
  children?: NavItem[];
}

export const navItems: NavItem[] = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/rules' },
  { label: '关于我们', href: '/about' },
];